import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import App from 'app/components/root-apps/basic-app';
import { baseMapStateToProps, baseNoAuthMapDispatchToProps, baseNoAuthPreload } from './base';
import clientPreload from './client-preload';

/**
 * Base App for cached SSR pages.  Uses clientPreload and baseNoAuthMapDispatchToProps to defer
 * clientside user specific info to client (componentDidMount)
 */
const BasicClientAuthApp = connect(baseMapStateToProps, baseNoAuthMapDispatchToProps)(preload(
  ({ dispatch, getState }) => baseNoAuthPreload(dispatch, getState()))(clientPreload(App)),
);

export default BasicClientAuthApp;



// WEBPACK FOOTER //
// ./app/common/containers/basic-client-auth-app.jsx